/* eslint-disable camelcase -- uses palette names from design source */
import {
  Approval,
  ApprovalGroup,
  ApprovalRequest,
  SelectedApprovals,
  TicketQueryResult,
} from '@totem/components/ticketing/ticketing';
import { isNotNull, isNull } from '@totem/utilities/common';

export const approvals_getByApprover = (
  approvals: Approval[],
  approverEmail: string,
) => {
  const pending = approvals.filter(
    (approval) =>
      approval.approverEmail === approverEmail && approval.status === 'SENT',
  );
  return pending;
};

export const approvalGroup_getByApprover = (
  group: ApprovalGroup,
  approverEmail: string,
) => {
  const pending: Approval[] = [];

  if (
    group.status === 'SENT' &&
    isNotNull(group.approvals) &&
    group.approvals.length > 0
  ) {
    const newApprovals = approvals_getByApprover(
      group.approvals,
      approverEmail,
    );
    if (newApprovals.length > 0) {
      pending.push(...newApprovals);
    }
  }

  if (isNotNull(group.groups) && group.groups.length > 0) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const newGroupApprovals = approvalGroups_getByApprover(
      group.groups,
      approverEmail,
    );
    if (newGroupApprovals.length > 0) {
      pending.push(...newGroupApprovals);
    }
  }

  return pending;
};

export const approvalGroups_getByApprover = (
  groups: ApprovalGroup[],
  approverEmail: string,
) => {
  const pending: Approval[] = [];

  groups.forEach((group) => {
    const newApprovals = approvalGroup_getByApprover(group, approverEmail);
    if (newApprovals.length > 0) {
      pending.push(...newApprovals);
    }
  });

  return pending;
};

export const approvalRequest_getByApprover = (
  request: ApprovalRequest,
  approverEmail: string,
): SelectedApprovals[] => {
  const approvalsFound = approvalGroup_getByApprover(
    request.approvalGroup,
    approverEmail,
  );

  return approvalsFound.map((approval) => {
    return {
      approvalRequest: request,
      approval,
    };
  });
};

export const approvalRequests_getByApprover = (
  requests: ApprovalRequest[],
  approverEmail: string,
): SelectedApprovals[] => {
  const selectedApprovals: SelectedApprovals[] = [];

  requests.forEach((request) => {
    const newApprovals = approvalRequest_getByApprover(request, approverEmail);
    if (newApprovals.length > 0) {
      selectedApprovals.push(...newApprovals);
    }
  });

  return selectedApprovals;
};

export const getPendingApprovals = (
  approver: string,
  ticket: TicketQueryResult,
): SelectedApprovals[] => {
  if (
    isNull(ticket) ||
    isNull(ticket.ticket) ||
    isNull(ticket.ticket.approvalRequests)
  ) {
    return [];
  }

  if (ticket.ticket.approvalRequests.length > 0) {
    return approvalRequests_getByApprover(
      ticket.ticket.approvalRequests,
      approver,
    );
  }

  return [];
};
